module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-leave-green-85040f.svg";